import { render, staticRenderFns } from "./PageSubmenu.vue?vue&type=template&id=a29d504c&scoped=true"
import script from "./PageSubmenu.vue?vue&type=script&lang=js"
export * from "./PageSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29d504c",
  null
  
)

export default component.exports